import React from 'react';
import { Text } from '@fluentui/react-components';
import { Box } from '../../../../theme/fluent';
import { useAppLayoutStyles } from '../../AppLayout.styles';
import { getColors } from '../../helpers/getColors';
import type { NavigationItemProps } from '../../AppLayout.types';

export const NavigationItem: React.FC<NavigationItemProps> = ({ item, isActive, isCollapsed, onClick }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const [isPressed, setIsPressed] = React.useState(false);

  const colors = getColors(isActive, isHovered, isPressed);
  const { classes } = useAppLayoutStyles();

  return (
    <Box className={classes.itemRoot}>
      {/* Left indicator - only visible when selected */}
      <Box className={classes.indicator}>{isActive && <Box className={classes.indicatorIsActive} />}</Box>

      {/* Button */}
      <Box
        as="div"
        role="button"
        tabIndex={0}
        aria-label={item.text}
        aria-current={isActive ? 'page' : undefined}
        onClick={onClick}
        onKeyDown={(event: React.KeyboardEvent) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick();
          }
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => {
          setIsHovered(false);
          setIsPressed(false);
        }}
        onMouseDown={() => setIsPressed(true)}
        onMouseUp={() => setIsPressed(false)}
        onFocus={() => setIsHovered(true)}
        onBlur={() => setIsHovered(false)}
        className={classes.menuButton}
        style={{
          paddingRight: isCollapsed ? '10px' : '8px',
          gap: isCollapsed ? '0' : '16px',
          backgroundColor: colors.backgroundColor,
        }}
      >
        <Box className={classes.menuButtonIconWrapper} style={{ color: colors.iconColor }}>
          {isActive && item.activeIcon ? item.activeIcon : item.icon}
        </Box>
        {!isCollapsed && (
          <Text
            size={300}
            weight={isActive ? 'semibold' : 'regular'}
            className={classes.menuButtonLabel}
            style={{ color: colors.textColor }}
          >
            {item.text}
          </Text>
        )}
      </Box>
    </Box>
  );
};
